import { updateTickerItems } from '@/mocks/home';

export default function UpdateTicker() {
  const loop = [...updateTickerItems, ...updateTickerItems];

  return (
    <div className="w-full bg-foreground-950 text-background-100">
      <div className="flex items-center">
        <div className="shrink-0 flex items-center gap-1.5 h-9 px-4 md:px-6 bg-primary-500 text-background-50">
          <i className="ri-flashlight-fill text-sm"></i>
          <span className="text-xs font-label font-medium whitespace-nowrap">实时更新</span>
        </div>
        <div className="relative flex-1 overflow-hidden h-9 flex items-center">
          <div className="flex items-center gap-10 whitespace-nowrap xl-marquee will-change-transform pl-6">
            {loop.map((text, index) => (
              <span key={index} className="text-xs font-label text-background-200/90">
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}